<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import { loadProgressBar } from 'axios-progress-bar'

loadProgressBar()

export default {
  components: {

  },
  name: 'App',
  mounted(){

  }
}

</script>
<style>
  html{
    font-size: 14px;
  }
  div, button, input{
    font-family: Poppins;
    overflow: visible;
  }
  table{
    font-size: 12px !important;
  }
</style>